export const dict = {
  id: {
    app_name: "CRM JFP",
    tagline: "CRM Perusahaan Jasa",
    subtitle: "Pantau klien, proposal, tender hingga closing dalam satu tempat.",
    sign_in_google: "Masuk dengan Google",
    sign_in: "Masuk",
    login: "Login",
    register: "Daftar",
    create_account: "Buat Akun",
    password: "Kata Sandi",
    or: "atau",
    account_created: "Akun berhasil dibuat",
    email_password_required: "Email & kata sandi wajib diisi",
    dashboard: "Dashboard",
    pipeline: "Pipeline",
    clients: "Klien",
    activities: "Aktivitas",
    reports: "Laporan",
    logout: "Keluar",
    kanban: "Kanban",
    table: "Tabel",
    add_deal: "Tambah Deal",
    add_client: "Tambah Klien",
    add_activity: "Tambah Aktivitas",
    new_deal: "Deal Baru",
    new_client: "Klien Baru",
    new_activity: "Aktivitas Baru",
    title: "Judul",
    name: "Nama",
    company: "Perusahaan",
    email: "Email",
    phone: "Telepon",
    industry: "Industri",
    tier: "Tier",
    notes: "Catatan",
    save: "Simpan",
    cancel: "Batal",
    delete: "Hapus",
    edit: "Ubah",
    client: "Klien",
    value: "Nilai",
    probability: "Probabilitas",
    stage: "Tahap",
    expected_close: "Perkiraan Closing",
    description: "Deskripsi",
    type: "Tipe",
    due_date: "Jatuh Tempo",
    completed: "Selesai",
    none: "Tidak ada",
    all: "Semua",
    search: "Cari...",
    total_pipeline: "Total Nilai Pipeline",
    weighted_forecast: "Perkiraan Berbobot",
    win_rate: "Win Rate",
    active_deals: "Deal Aktif",
    total_clients: "Total Klien",
    recent_activities: "Aktivitas Terbaru",
    deals_by_stage: "Deal per Tahap",
    revenue_by_stage: "Nilai per Tahap",
    win_loss: "Menang vs Kalah",
    no_data: "Belum ada data",
    empty_deals: "Belum ada deal. Klik Tambah Deal untuk memulai.",
    empty_clients: "Belum ada klien. Tambahkan klien pertama Anda.",
    empty_activities: "Belum ada aktivitas.",
    signing_in: "Menandatangani sesi...",
    hello: "Halo",
    welcome_back: "Selamat datang kembali",
    filter_stage: "Filter Tahap",
    contact: "Kontak",
    deals: "Deal",
    call: "Telepon",
    meeting: "Rapat",
    task: "Tugas",
    note: "Catatan",
    overdue: "Terlambat",
    today: "Hari ini",
    upcoming: "Akan datang",
    enterprise: "Enterprise",
    smb: "UKM",
    government: "Pemerintah",
    information: "Informasi",
    prospecting: "Prospek",
    praqualification: "Prakualifikasi",
    proposal: "Proposal",
    tender: "Tender",
    negotiation: "Negosiasi",
    contract: "Kontrak",
    closing_won: "Kontrak",
    closing_lost: "Closing Gagal",
    select_client: "Pilih klien",
    select_stage: "Pilih tahap",
    select_type: "Pilih tipe",
    won_count: "Deal Menang",
    lost_count: "Deal Gagal",
    quick_actions: "Aksi Cepat",
    view_all: "Lihat semua",
    landing_hero: "Pantau setiap tahap: proposal, tender, sampai closing.",
    landing_features_1: "Pipeline Kanban",
    landing_features_1_desc: "Pindahkan deal antar tahap dengan cepat dan visual.",
    landing_features_2: "Manajemen Klien",
    landing_features_2_desc: "Segmentasi klien enterprise, UKM, dan pemerintah.",
    landing_features_3: "Analitik Real-Time",
    landing_features_3_desc: "KPI, win rate, dan forecast dalam satu dashboard.",
    team: "Tim",
    team_members: "anggota tim",
    approvals: "Persetujuan",
    pending_approvals: "Menunggu Persetujuan",
    role: "Level Akses",
    admin: "Admin",
    editor: "Editor",
    approver: "Approver",
    viewer: "Viewer",
    no_access: "Tanpa Akses",
    add_member: "Tambah Anggota",
    new_member: "Anggota Baru",
    reset_password: "Reset Kata Sandi",
    you: "Anda",
    created_by: "Dibuat oleh",
    updated_by: "Diubah oleh",
    no_access_title: "Akun Anda belum diberi akses",
    no_access_desc: "Admin belum memberikan level akses untuk akun ini. Hubungi admin workspace agar Anda diberi akses ke data CRM.",
    read_only_notice: "Level akses Anda hanya bisa melihat data.",
    awaiting_approval: "Menunggu persetujuan",
    approve: "Setujui",
    reject: "Tolak",
    approved: "Disetujui",
    rejected: "Ditolak",
    pending: "Menunggu",
    comments: "Komentar",
    add_comment: "Tulis komentar...",
    no_comments: "Belum ada komentar.",
    send: "Kirim",
    requested_by: "Diminta oleh",
    decided_by: "Diputuskan oleh",
    history: "Riwayat",
    no_pending_approvals: "Tidak ada permintaan yang menunggu persetujuan.",
    member_created: "Anggota berhasil dibuat",
    member_updated: "Anggota diperbarui",
    member_deleted: "Anggota dihapus",
    delete_member_confirm: "Hapus anggota",
    stage_request_sent: "Perubahan tahap dikirim untuk persetujuan approver",
    role_desc_admin: "akses penuh + kelola anggota tim & level akses",
    role_desc_editor: "input & ubah klien, deal, aktivitas (perubahan tahap perlu persetujuan)",
    role_desc_approver: "melihat semua data, menyetujui/menolak perubahan tahap & memberi komentar",
    role_desc_viewer: "hanya melihat data, tidak bisa mengubah",
    role_desc_no_access: "bisa login tetapi tidak melihat data apa pun",
    level_1: "Level 1",
    level_2: "Level 2",
    level_3: "Level 3",
    profile: "Profil Saya",
    change_password: "Ubah Kata Sandi",
    current_password: "Kata Sandi Saat Ini",
    new_password: "Kata Sandi Baru",
    confirm_password: "Konfirmasi Kata Sandi Baru",
    password_changed: "Kata sandi berhasil diubah",
    password_min: "Kata sandi minimal 6 karakter",
    password_mismatch: "Konfirmasi kata sandi tidak sama",
    set_password_notice: "Akun Anda login lewat Google dan belum punya kata sandi. Buat kata sandi di bawah agar bisa login dengan email juga.",
    needs_approval_hint: "perlu persetujuan approver",
    approve_in_approvals_page: "Persetujuan dilakukan di menu Persetujuan",
    approved_stage_applied: "Disetujui — tahap deal langsung diperbarui",
    pic: "PIC",
    change_pic: "Ubah PIC",
    pic_updated: "PIC diperbarui",
    scope: "Lingkup Pekerjaan",
    scope_placeholder: "contoh: DED renovasi IGD 2 lantai",
    progress_log: "Log Progres",
    add_progress: "Tambah Entri Progres",
    progress_date: "Tanggal",
    progress_type: "Jenis",
    progress_summary: "Ringkasan (apa yang dikerjakan)",
    progress_outcome: "Hasil",
    next_action: "Tindakan Berikutnya",
    next_action_due: "Target Tindakan",
    attachment_link: "Tautan Lampiran",
    no_progress: "Belum ada entri progres.",
    summary_required: "Ringkasan wajib diisi",
    progress_added: "Entri progres ditambahkan",
    progress_updated: "Entri progres diperbarui",
    progress_deleted: "Entri progres dihapus",
    site_survey: "Survei Lokasi",
    document: "Dokumen",
    follow_up: "Tindak Lanjut",
    other: "Lainnya",
    positive: "Positif",
    neutral: "Netral",
    blocker: "Hambatan",
    optional: "opsional",
    audit_log: "Log Aktivitas",
    show_stages: "Tampilkan Tahap",
    select_all_stages: "Pilih semua tahap",
    clear_stages: "Kosongkan pilihan",
    sort_stage_asc: "Informasi → Closing",
    sort_stage_desc: "Closing → Informasi",
    audit_entries: "catatan",
    no_audit_log: "Belum ada catatan aktivitas.",
    "act_deal:assign_pic": "mengubah PIC deal",
    "act_progress:delete": "menghapus entri progres",
    "act_progress:update": "mengubah entri progres",
    "act_client:delete": "menghapus klien",
    "act_activity:delete": "menghapus aktivitas",
    "act_deal:delete": "menghapus deal",
    "act_stage:approved": "menyetujui perubahan tahap",
    "act_stage:rejected": "menolak perubahan tahap",
    "act_user:create": "membuat anggota",
    "act_user:role_change": "mengubah level akses",
    "act_user:delete": "menghapus anggota",
    "act_user:password_reset": "reset kata sandi anggota",
    "act_auth:password_change": "mengubah kata sandinya sendiri",
    "act_deal:pnl_update": "memperbarui laba rugi deal",
    "act_stage:create": "menambah tahap",
    "act_stage:update": "mengubah tahap",
    "act_stage:delete": "menghapus tahap",
    "act_stage:reorder": "mengurutkan ulang tahap",
    "act_service:create": "menambah jasa",
    "act_service:update": "mengubah jasa",
    "act_service:delete": "menghapus jasa",
    "act_settings:update": "mengubah pengaturan",
    expected_spk: "Perkiraan SPK",
    expected_completion: "Perkiraan Selesai",
    expected_spk_date: "Perkiraan SPK",
    expected_close_date: "Perkiraan Closing",
    expected_completion_date: "Perkiraan Selesai",
    service: "Jasa",
    detail_tab: "Detail",
    pnl: "Laba Rugi",
    est_profit: "Estimasi Laba Rugi",
    revenue: "Pendapatan",
    expenses: "Pengeluaran",
    expense_label: "Nama biaya",
    add_expense: "Tambah Biaya",
    no_expenses: "Belum ada biaya. Tambahkan untuk menghitung laba rugi.",
    total_expense: "Total Biaya",
    gross_profit: "Laba Kotor",
    tax: "Pajak",
    tax_percent: "Pajak (%)",
    net_profit: "Laba Bersih",
    margin: "Margin",
    pnl_locked: "Laba rugi hanya dapat dilihat oleh Admin dan PIC deal ini.",
    pnl_saved: "Laba rugi tersimpan",
    administration: "Administrasi",
    admin_desc: "Kelola anggota, tahap pipeline, daftar jasa, dan pengaturan umum.",
    stages_config: "Tahap",
    services_config: "Jasa",
    general_settings: "Pengaturan",
    stages_desc: "Atur nama, urutan, warna, dan probabilitas tiap tahap pipeline. Tahap inti tidak bisa dihapus.",
    services_desc: "Daftar jasa yang bisa dipilih pada setiap deal.",
    add_stage: "Tambah Tahap",
    stage_label_id: "Nama (Indonesia)",
    stage_label_en: "Nama (English)",
    stage_color: "Warna",
    stage_saved: "Tahap tersimpan",
    stage_deleted: "Tahap dihapus",
    stage_labels_required: "Nama Indonesia & English wajib diisi",
    add_service: "Tambah Jasa",
    service_name: "Nama Jasa",
    service_name_required: "Nama jasa wajib diisi",
    service_saved: "Jasa tersimpan",
    service_deleted: "Jasa dihapus",
    no_services: "Belum ada jasa. Tambahkan jasa pertama Anda.",
    company_name: "Nama Perusahaan",
    company_email: "Email Perusahaan",
    currency: "Mata Uang",
    default_tax: "Pajak Bawaan",
    expense_labels: "Preset Nama Biaya",
    settings_saved: "Pengaturan tersimpan",
    status: "Status",
    active: "Aktif",
    inactive: "Nonaktif",
    add: "Tambah",
    search_deals: "Cari deal...",
    sort_by: "Urut",
    ascending: "Naik",
    descending: "Turun",
    reset_filters: "Reset",
    all_pics: "Semua PIC",
    delete_deal_confirm: "Hapus deal ini? Hanya Admin atau PIC yang bisa menghapus.",
    delete_restricted: "Hanya Admin atau penanggung jawab yang bisa menghapus data ini.",
    no_matching_deals: "Tidak ada deal yang cocok dengan filter. Coba reset filter.",
    latest_200: "menampilkan 200 terbaru",
    auth_badge: "Khusus tim sales & operasional",
    auth_footer: "Akses hanya untuk karyawan · Setiap aktivitas tercatat di audit log",
    signin_intro: "Gunakan akun Google kantor Anda, atau email & kata sandi yang diberikan admin.",
    or_with_email: "atau dengan email",
    checking: "Memeriksa…",
    no_access_yet: "Belum punya akses?",
    create_account_title: "Daftar akun",
    register_intro: "Gunakan akun Google kantor Anda. Setelah masuk pertama kali, admin akan memberikan akses sesuai peran Anda.",
    register_google: "Daftar dengan Google",
    register_step_1: "Masuk dengan akun Google kantor Anda.",
    register_step_2: "Admin menerima pemberitahuan dan menetapkan peran Anda.",
    register_step_3: "Setelah disetujui, Anda bisa langsung menggunakan CRM.",
    have_access: "Sudah punya akses?",
    "act_expense:create": "mencatat expense",
    "act_expense:update": "mengubah expense",
    "act_expense:void": "mem-void expense",
    "act_expense_account:create": "menambah akun expense",
    "act_expense_account:update": "mengubah akun expense",
    "act_beneficiary:create": "menambah beneficiary",
    "act_beneficiary:update": "mengubah beneficiary",
    record_expense: "Catat Expense",
    edit_expense: "Edit Expense",
    void_expense: "Void Expense",
    expense_detail: "Detail Expense",
    transaction_date: "Tanggal Transaksi",
    date: "Tanggal",
    beneficiary: "Beneficiary",
    beneficiaries: "Beneficiary",
    beneficiary_placeholder: "Ketik nama penerima",
    will_be_added_to_master: "akan ditambahkan ke master",
    number: "Nomor",
    auto_number: "(otomatis)",
    reference: "Referensi",
    reference_placeholder: "No. kwitansi / invoice vendor",
    expense_lines: "Rincian",
    add_line: "Tambah baris",
    expense_account: "Akun Expense",
    expense_accounts: "Akun Expense",
    select_account: "pilih akun",
    amount: "Jumlah",
    sub_total: "Sub Total",
    total: "Total",
    save_and_post: "Simpan & Posting",
    save_changes: "Simpan Perubahan",
    change_reason: "Alasan perubahan",
    change_reason_placeholder: "Contoh: koreksi nominal sesuai kwitansi",
    void_reason: "Alasan void",
    void_warning: "{number} akan dikeluarkan dari seluruh perhitungan P&L. Dokumen tetap tersimpan dan tercatat di riwayat.",
    expense_edit_warning: "{number} sudah diposting ke P&L. Perubahan wajib diberi alasan dan akan tercatat di riwayat dokumen serta Activity Log.",
    expense_posted: "Expense diposting",
    expense_updated: "Perubahan expense tersimpan",
    expense_voided: "Expense di-void",
    no_changes: "Tidak ada perubahan",
    field_required: "Wajib diisi",
    amount_must_be_positive: "Jumlah harus lebih dari 0",
    check_the_form: "Periksa kembali isian form",
    status_posted: "Posted",
    status_void: "Void",
    status_needs_completion: "Perlu dilengkapi",
    show_void: "Tampilkan void",
    posted_expense_total: "Total expense terposting",
    summary_per_account: "Ringkasan per akun",
    lines_suffix: "baris",
    expense_action_created: "Dibuat",
    expense_action_edited: "Diedit",
    expense_action_voided: "Di-void",
    expense_action_migrated: "Dimigrasi dari expense lama",
    view_only_mode: "Mode lihat saja",
    actions: "Aksi",
    deal: "Deal",
    accounts_desc: "Daftar akun expense (COA) yang dipakai saat mencatat expense. Akun yang sudah dipakai cukup dinonaktifkan.",
    add_account: "Tambah Akun",
    account_code: "Kode",
    account_name: "Nama Akun",
    account_group: "Grup",
    account_saved: "Akun tersimpan",
    beneficiaries_desc: "Daftar penerima pembayaran: vendor, tenaga ahli, karyawan, atau lainnya.",
    add_beneficiary: "Tambah Beneficiary",
    beneficiary_saved: "Beneficiary tersimpan",
    no_beneficiaries: "Belum ada beneficiary. Tambahkan dari sini atau langsung dari form expense.",
    account_number: "No. Rekening",
    ben_vendor: "Vendor",
    ben_expert: "Tenaga Ahli",
    ben_employee: "Karyawan",
    ben_other: "Lainnya",
  },
  en: {
    app_name: "CRM JFP",
    tagline: "Service Company CRM",
    subtitle: "Track clients, proposals, tenders and closings in one place.",
    sign_in_google: "Sign in with Google",
    sign_in: "Sign In",
    login: "Login",
    register: "Register",
    create_account: "Create Account",
    password: "Password",
    or: "or",
    account_created: "Account created",
    email_password_required: "Email & password are required",
    dashboard: "Dashboard",
    pipeline: "Pipeline",
    clients: "Clients",
    activities: "Activities",
    reports: "Reports",
    logout: "Logout",
    kanban: "Kanban",
    table: "Table",
    add_deal: "Add Deal",
    add_client: "Add Client",
    add_activity: "Add Activity",
    new_deal: "New Deal",
    new_client: "New Client",
    new_activity: "New Activity",
    title: "Title",
    name: "Name",
    company: "Company",
    email: "Email",
    phone: "Phone",
    industry: "Industry",
    tier: "Tier",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    client: "Client",
    value: "Value",
    probability: "Probability",
    stage: "Stage",
    expected_close: "Expected Close",
    description: "Description",
    type: "Type",
    due_date: "Due Date",
    completed: "Completed",
    none: "None",
    all: "All",
    search: "Search...",
    total_pipeline: "Total Pipeline Value",
    weighted_forecast: "Weighted Forecast",
    win_rate: "Win Rate",
    active_deals: "Active Deals",
    total_clients: "Total Clients",
    recent_activities: "Recent Activities",
    deals_by_stage: "Deals by Stage",
    revenue_by_stage: "Value by Stage",
    win_loss: "Win vs Loss",
    no_data: "No data yet",
    empty_deals: "No deals yet. Click Add Deal to start.",
    empty_clients: "No clients yet. Add your first client.",
    empty_activities: "No activities yet.",
    signing_in: "Signing you in...",
    hello: "Hello",
    welcome_back: "Welcome back",
    filter_stage: "Filter Stage",
    contact: "Contact",
    deals: "Deals",
    call: "Call",
    meeting: "Meeting",
    task: "Task",
    note: "Note",
    overdue: "Overdue",
    today: "Today",
    upcoming: "Upcoming",
    enterprise: "Enterprise",
    smb: "SMB",
    government: "Government",
    information: "Information",
    prospecting: "Prospecting",
    praqualification: "Praqualification",
    proposal: "Proposal Sent",
    tender: "Tender Process",
    negotiation: "Negotiation",
    contract: "Contract",
    closing_won: "Contract",
    closing_lost: "Closed Lost",
    select_client: "Select client",
    select_stage: "Select stage",
    select_type: "Select type",
    won_count: "Deals Won",
    lost_count: "Deals Lost",
    quick_actions: "Quick Actions",
    view_all: "View all",
    landing_hero: "Track every stage: proposal, tender, all the way to closing.",
    landing_features_1: "Kanban Pipeline",
    landing_features_1_desc: "Move deals between stages fast and visually.",
    landing_features_2: "Client Management",
    landing_features_2_desc: "Segment enterprise, SMB and government clients.",
    landing_features_3: "Real-time Analytics",
    landing_features_3_desc: "KPIs, win rate and forecast on one dashboard.",
    team: "Team",
    team_members: "team members",
    approvals: "Approvals",
    pending_approvals: "Pending Approvals",
    role: "Access Level",
    admin: "Admin",
    editor: "Editor",
    approver: "Approver",
    viewer: "Viewer",
    no_access: "No Access",
    add_member: "Add Member",
    new_member: "New Member",
    reset_password: "Reset Password",
    you: "you",
    created_by: "Created by",
    updated_by: "Updated by",
    no_access_title: "Your account has no access yet",
    no_access_desc: "An admin has not granted an access level to this account yet. Contact your workspace admin to get access to the CRM data.",
    read_only_notice: "Your access level is read-only.",
    awaiting_approval: "Awaiting approval",
    approve: "Approve",
    reject: "Reject",
    approved: "Approved",
    rejected: "Rejected",
    pending: "Pending",
    comments: "Comments",
    add_comment: "Write a comment...",
    no_comments: "No comments yet.",
    send: "Send",
    requested_by: "Requested by",
    decided_by: "Decided by",
    history: "History",
    no_pending_approvals: "No requests awaiting approval.",
    member_created: "Member created",
    member_updated: "Member updated",
    member_deleted: "Member deleted",
    delete_member_confirm: "Delete member",
    stage_request_sent: "Stage change submitted for approval",
    role_desc_admin: "full access + manage team members and access levels",
    role_desc_editor: "create & edit clients, deals, activities (stage changes need approval)",
    role_desc_approver: "view all data, approve/reject stage changes and comment",
    role_desc_viewer: "view only, cannot make changes",
    role_desc_no_access: "can sign in but sees no data",
    level_1: "Level 1",
    level_2: "Level 2",
    level_3: "Level 3",
    profile: "My Profile",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm New Password",
    password_changed: "Password changed successfully",
    password_min: "Password must be at least 6 characters",
    password_mismatch: "Password confirmation does not match",
    set_password_notice: "Your account signs in with Google and has no password yet. Create one below so you can also sign in with email.",
    needs_approval_hint: "needs approver sign-off",
    approve_in_approvals_page: "Approvals are handled on the Approvals page",
    approved_stage_applied: "Approved — deal stage updated instantly",
    pic: "PIC",
    change_pic: "Change PIC",
    pic_updated: "PIC updated",
    scope: "Scope",
    scope_placeholder: "e.g. DED renovasi IGD 2 lantai",
    progress_log: "Progress Log",
    add_progress: "Add Progress Entry",
    progress_date: "Date",
    progress_type: "Type",
    progress_summary: "Summary (what was done)",
    progress_outcome: "Outcome",
    next_action: "Next Action",
    next_action_due: "Next Action Due",
    attachment_link: "Attachment Link",
    no_progress: "No progress entries yet.",
    summary_required: "Summary is required",
    progress_added: "Progress entry added",
    progress_updated: "Progress entry updated",
    progress_deleted: "Progress entry deleted",
    site_survey: "Site Survey",
    document: "Document",
    follow_up: "Follow-up",
    other: "Other",
    positive: "Positive",
    neutral: "Neutral",
    blocker: "Blocker",
    optional: "optional",
    audit_log: "Activity Log",
    show_stages: "Show Stages",
    select_all_stages: "Select all stages",
    clear_stages: "Clear selection",
    sort_stage_asc: "Information → Closing",
    sort_stage_desc: "Closing → Information",
    audit_entries: "entries",
    no_audit_log: "No activity recorded yet.",
    "act_deal:assign_pic": "changed the deal PIC",
    "act_progress:delete": "deleted a progress entry",
    "act_progress:update": "edited a progress entry",
    "act_client:delete": "deleted a client",
    "act_activity:delete": "deleted an activity",
    "act_deal:delete": "deleted a deal",
    "act_stage:approved": "approved a stage change",
    "act_stage:rejected": "rejected a stage change",
    "act_user:create": "created a member",
    "act_user:role_change": "changed an access level",
    "act_user:delete": "deleted a member",
    "act_user:password_reset": "reset a member password",
    "act_auth:password_change": "changed their own password",
    "act_deal:pnl_update": "updated a deal P&L",
    "act_stage:create": "created a stage",
    "act_stage:update": "edited a stage",
    "act_stage:delete": "deleted a stage",
    "act_stage:reorder": "reordered the stages",
    "act_service:create": "created a service",
    "act_service:update": "edited a service",
    "act_service:delete": "deleted a service",
    "act_settings:update": "updated the settings",
    expected_spk: "Expected SPK",
    expected_completion: "Expected Completion",
    expected_spk_date: "Expected SPK",
    expected_close_date: "Expected Close",
    expected_completion_date: "Expected Completion",
    service: "Service",
    detail_tab: "Details",
    pnl: "P&L",
    est_profit: "Est. Profit",
    revenue: "Revenue",
    expenses: "Expenses",
    expense_label: "Expense label",
    add_expense: "Add Expense",
    no_expenses: "No expenses yet. Add some to compute the P&L.",
    total_expense: "Total Expense",
    gross_profit: "Gross Profit",
    tax: "Tax",
    tax_percent: "Tax (%)",
    net_profit: "Net Profit",
    margin: "Margin",
    pnl_locked: "The P&L is visible to admins and this deal's PIC only.",
    pnl_saved: "P&L saved",
    administration: "Administration",
    admin_desc: "Manage members, pipeline stages, services and general settings.",
    stages_config: "Stages",
    services_config: "Services",
    general_settings: "Settings",
    stages_desc: "Configure the label, order, colour and probability of each pipeline stage. Core stages cannot be deleted.",
    services_desc: "The list of services selectable on each deal.",
    add_stage: "Add Stage",
    stage_label_id: "Label (Indonesian)",
    stage_label_en: "Label (English)",
    stage_color: "Colour",
    stage_saved: "Stage saved",
    stage_deleted: "Stage deleted",
    stage_labels_required: "Both Indonesian and English labels are required",
    add_service: "Add Service",
    service_name: "Service Name",
    service_name_required: "Service name is required",
    service_saved: "Service saved",
    service_deleted: "Service deleted",
    no_services: "No services yet. Add your first one.",
    company_name: "Company Name",
    company_email: "Company Email",
    currency: "Currency",
    default_tax: "Default Tax",
    expense_labels: "Expense Label Presets",
    settings_saved: "Settings saved",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    add: "Add",
    search_deals: "Search deals...",
    sort_by: "Sort",
    ascending: "Ascending",
    descending: "Descending",
    reset_filters: "Reset",
    all_pics: "All PICs",
    delete_deal_confirm: "Delete this deal? Only an admin or the PIC can delete it.",
    delete_restricted: "Only an admin or the responsible person can delete this record.",
    no_matching_deals: "No deals match the current filters. Try resetting them.",
    latest_200: "showing the latest 200",
    auth_badge: "For sales & operations teams only",
    auth_footer: "Employees only · Every action is recorded in the audit log",
    signin_intro: "Use your work Google account, or the email & password provided by an admin.",
    or_with_email: "or with email",
    checking: "Checking…",
    no_access_yet: "Don't have access yet?",
    create_account_title: "Create an account",
    register_intro: "Use your work Google account. After your first sign-in, an admin will grant access based on your role.",
    register_google: "Register with Google",
    register_step_1: "Sign in with your work Google account.",
    register_step_2: "An admin is notified and assigns your role.",
    register_step_3: "Once approved, you can start using the CRM right away.",
    have_access: "Already have access?",
    "act_expense:create": "recorded an expense",
    "act_expense:update": "edited an expense",
    "act_expense:void": "voided an expense",
    "act_expense_account:create": "created an expense account",
    "act_expense_account:update": "edited an expense account",
    "act_beneficiary:create": "created a beneficiary",
    "act_beneficiary:update": "edited a beneficiary",
    record_expense: "Record Expense",
    edit_expense: "Edit Expense",
    void_expense: "Void Expense",
    expense_detail: "Expense Detail",
    transaction_date: "Transaction Date",
    date: "Date",
    beneficiary: "Beneficiary",
    beneficiaries: "Beneficiaries",
    beneficiary_placeholder: "Type the payee name",
    will_be_added_to_master: "will be added to the master list",
    number: "Number",
    auto_number: "(automatic)",
    reference: "Reference",
    reference_placeholder: "Receipt / vendor invoice no.",
    expense_lines: "Lines",
    add_line: "Add line",
    expense_account: "Expense Account",
    expense_accounts: "Expense Accounts",
    select_account: "select an account",
    amount: "Amount",
    sub_total: "Sub Total",
    total: "Total",
    save_and_post: "Save & Post",
    save_changes: "Save Changes",
    change_reason: "Reason for the change",
    change_reason_placeholder: "e.g. amount corrected against the receipt",
    void_reason: "Void reason",
    void_warning: "{number} will be excluded from every P&L figure. The document stays on file and in the history.",
    expense_edit_warning: "{number} is already posted to the P&L. Any change needs a reason and is recorded in the document history and the Activity Log.",
    expense_posted: "Expense posted",
    expense_updated: "Expense changes saved",
    expense_voided: "Expense voided",
    no_changes: "No changes to save",
    field_required: "Required",
    amount_must_be_positive: "Amount must be greater than 0",
    check_the_form: "Please check the form",
    status_posted: "Posted",
    status_void: "Void",
    status_needs_completion: "Needs completion",
    show_void: "Show void",
    posted_expense_total: "Posted expense total",
    summary_per_account: "Summary per account",
    lines_suffix: "lines",
    expense_action_created: "Created",
    expense_action_edited: "Edited",
    expense_action_voided: "Voided",
    expense_action_migrated: "Migrated from the legacy expense list",
    view_only_mode: "View-only mode",
    actions: "Actions",
    deal: "Deal",
    accounts_desc: "The expense accounts (COA) used when recording an expense. Accounts already in use can only be deactivated.",
    add_account: "Add Account",
    account_code: "Code",
    account_name: "Account Name",
    account_group: "Group",
    account_saved: "Account saved",
    beneficiaries_desc: "Payees: vendors, experts, employees or others.",
    add_beneficiary: "Add Beneficiary",
    beneficiary_saved: "Beneficiary saved",
    no_beneficiaries: "No beneficiaries yet. Add one here or straight from the expense form.",
    account_number: "Bank Account",
    ben_vendor: "Vendor",
    ben_expert: "Expert",
    ben_employee: "Employee",
    ben_other: "Other",
  },
};

export const STAGES = [
  "information", "prospecting", "praqualification", "proposal",
  "tender", "negotiation", "contract", "closing_lost",
];

// Dashboard & Reports: highest weight first (contract → information), lost last
export const STAGES_BY_WEIGHT = [
  "contract", "negotiation", "tender", "proposal",
  "praqualification", "prospecting", "information", "closing_lost",
];

// Pipeline stage filter: pipeline flow order (information → contract), Closed Lost last
export const STAGES_FILTER = [
  "information", "prospecting", "praqualification", "proposal",
  "tender", "negotiation", "contract", "closing_lost",
];

export const PROGRESS_TYPES = ["contact", "meeting", "site_survey", "proposal", "negotiation", "document", "follow_up", "other"];
export const PROGRESS_OUTCOMES = ["positive", "neutral", "blocker"];
export const OUTCOME_STYLES = {
  positive: "bg-emerald-50 text-emerald-700 border-emerald-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
  blocker: "bg-rose-50 text-rose-700 border-rose-200",
};

export const STAGE_STYLES = {
  information: { bg: "bg-slate-100", border: "border-slate-200", text: "text-slate-700", dot: "bg-slate-400" },
  prospecting: { bg: "bg-sky-50", border: "border-sky-200", text: "text-sky-700", dot: "bg-sky-500" },
  praqualification: { bg: "bg-cyan-50", border: "border-cyan-200", text: "text-cyan-700", dot: "bg-cyan-500" },
  proposal:    { bg: "bg-violet-50", border: "border-violet-200", text: "text-violet-700", dot: "bg-violet-500" },
  tender:      { bg: "bg-orange-50", border: "border-orange-200", text: "text-orange-700", dot: "bg-orange-500" },
  negotiation: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", dot: "bg-amber-500" },
  contract:    { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", dot: "bg-emerald-500" },
  closing_won: { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", dot: "bg-emerald-500" },
  closing_lost:{ bg: "bg-rose-50", border: "border-rose-200", text: "text-rose-700", dot: "bg-rose-500" },
};
